import { useEffect } from 'react'
import { useGetProfileInfo, useUpdateProfileInfo } from '../../hook/user'
import Button from '../Button'
import CheckBox from '../Checkbox'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

export default function Notifications() {

    const getProfile = useGetProfileInfo()
    const updateProfile = useUpdateProfileInfo()

    const formik = useFormik({
        initialValues: {
            email_notification: false,
            sms_notification: false,
        },
        onSubmit: (values) => {
            updateProfile.mutateAsync(values).then((_) => {
                toast.success('The operation done successfully')
            }).catch((err) => {
                toast.error(err.response?.data?.message)
            })
        }
    })

    useEffect(() => {
      
        if(getProfile.data) {
            formik.setFieldValue('email_notification', getProfile.data?.email_notification)
            formik.setFieldValue('sms_notification', getProfile.data?.sms_notification)
        }

    }, [getProfile.data])
    

    return (
        <div className='p-5'>
            <div className='text-xs'>
                Receive Notifications Via
            </div>
            <div className='mt-2 h-12 px-4 border border-border rounded-md flex justify-between items-center'>
                <div className='text-sm'>
                    By Email
                </div>
                <CheckBox
                    checked={formik.values.email_notification}
                    onChange={(value) => formik.setFieldValue('email_notification', value)}
                />
            </div>
            <div className='mt-2 h-12 px-4 border border-border rounded-md flex justify-between items-center'>
                <div className='text-sm'>
                    By SMS
                </div>
                <CheckBox
                    checked={formik.values.sms_notification}
                    onChange={(value) => formik.setFieldValue('sms_notification', value)}
                />
            </div>

            <div className='mt-8'>
                <Button
                    title='Save Changes'
                    onClick={formik.handleSubmit}
                    isLoading={updateProfile.isLoading}
                />
            </div>
        </div>
    )
}
